import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/backend/layout.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: () =>import('@/views/login.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () =>import('@/views/login.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/tapd/logout',
      name: 'tapdLogout',
      component: () =>import('@/views/landingPage.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/landingPage',
      name: 'landingPage',
      component: () =>import('@/views/landingPage.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/userInfo',
      name: 'userInfo',
      component: () =>import('@/views/userInfo.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/appManage',
      name: 'appManage',
      component: () =>import('@/views/appManage.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/tapd/login',
      name: 'tapdLogin',
      component: () =>import('@/views/tapdLogin.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/git/login',
      name: 'gitLogin',
      component: () =>import('@/views/gitLogin.vue'),
      meta: {
        permission: false,
        allowBack: true,
        noCache: true
      }
    },
    {
      path: '/backend',
      name: 'backend',
      component: layout,
      children: [
        {
          path: '/userList',
          name: 'userList',
          component: () => import('@/views/backend/user/index.vue'),
        },
        {
          path: '/departmentList',
          name: 'departmentList',
          component: () => import('@/views/backend/department/index.vue'),
        },
        {
          path: '/appList',
          name: 'appList',
          component: () => import('@/views/backend/app/index.vue'),
        },
        {
          path: '/logList',
          name: 'logList',
          component: () => import('@/views/backend/log/index.vue'),
        }
      ]
    },
    {
      path: '*',
      component: () =>import('@/views/notFound.vue'),
    }
  ]
})
